import {
  Box,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { productCompleteManufacturing } from "../../../slices/manufacturer";
import FormikControl from "../FormikControl";
import { selectCurrentCycle } from "../../../slices/common";
import moment from 'moment'

const initialValues = {
  infusion_date:new Date(),
};

const MarkAsCompleteForm = (
  formProps
) => {
    const dispatch = useDispatch();
    const currentCycle = useSelector(selectCurrentCycle)
    const validationSchema = Yup.object().shape({
    infusion_date: Yup.string().required("Please select a date")
    });

  const handleSubmit = async (values) => {
    try {
      // Prepare API payload with the selected restart option
      const payload = {
        subject_id: formProps?.subject_id,
        feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,        
        qr_code_generated_id: currentCycle?.qr_code_generation_id,
        manufacturer_date: moment(values?.infusion_date, "DD/MM/YYYY").format("YYYY-MM-DD")
      };
        const res = await dispatch(productCompleteManufacturing(payload)).unwrap();
      if (res?.status === 200) {
        formProps.handleFormSubmit();
      }
    } catch (err) {
      console.error("Error restarting manufacturing:", err);
    }
  };


  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const formOptions = [
        {
          label: 'Manufacturer Date',
          type: 'date',
          name: 'infusion_date',
          placeholder: 'Enter Date',
          max: new Date(),
          required: true,
        }
  ];
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              // loading={isLoading}
              sx={{ backgroundColor: "#3571FF" }}
            >
             Submit
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default MarkAsCompleteForm;
